import { AccountVerification, Utils } from 'common';
import React, { Component } from 'react';

const { AccountVerify } = AccountVerification;
const { Session, Util, Navigation } = Utils;

class AccountVerificationWrapper extends Component {
	constructor(props) {
		super(props);

		const isEmailOnly =
			Session.getAccountInfo().accountVerificationOption === 'email';

		this.state = {
			area: Util.getQueryParamByName('c') || '',
			accountVerifyRedirectApp: Util.getQueryParamByName('redirectApp'),
			isEmailOnly,
		};
	}

	accountVerifyCompletionCallback = success => {
		const { IsInWinClient, AllowedTargetOrigin } = Session.getSettings();
		const { area, accountVerifyRedirectApp } = this.state;
		const { app } = this.props;

		if (IsInWinClient) {
			// Windows client callback
			window.close();
		} else if (area === 'webreg') {
			// Webreg callback
			const url = `${document.referrer}registration/reg/ppawr`;

			Util.postMessage(success, url);
		} else if (accountVerifyRedirectApp && success) {
			Navigation.navigateTo(accountVerifyRedirectApp);
		} else if (app === 'account' && success) {
			window.location.reload();
		} else {
			// EXT app callback
			try {
				Util.postMessage(
					{ type: 'AccountVerify', success },
					AllowedTargetOrigin
				);
			} catch (error) {
				console.log(error);
			}
		}
	};

	render() {
		const { area, isEmailOnly } = this.state;
		const queryPhoneNumber = Util.getQueryParamByName('p') || '';
		const queryEmail = Util.getQueryParamByName('e') || '';
		const hasHeader = !window.location.pathname.includes('noheader');
		const showSuccess =
			area === 'webreg'
				? false
				: Util.getQueryParamByName('showSuccess') === 'false' || true;

		return (
			<div className="account-verification">
				{hasHeader && (
					<h1 className="account-verification-with-header">
						Account Verification
					</h1>
				)}
				<AccountVerify
					showSuccess={showSuccess}
					requestedEmail={queryEmail}
					requestedPhoneNumber={queryPhoneNumber}
					completionCallback={this.accountVerifyCompletionCallback}
					emailOnly={isEmailOnly}
				/>
			</div>
		);
	}
}

export default AccountVerificationWrapper;
